// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"9638af0d","145":"506a5245","150":"8c505b81","167":"c4841973","173":"a3accae6","204":"b4744b2d","522":"421b6ffb","523":"f419a32d","577":"4b6bf324","787":"37f0c89a","940":"9139edf1","968":"e53e990d"}[chunkId] + ".chunk.js";
};